module.exports = globalThis["React"];